import { render } from "./EditKinkekaartInfo.vue?vue&type=template&id=8bf6f9a0"
import script from "./EditKinkekaartInfo.vue?vue&type=script&lang=js"
export * from "./EditKinkekaartInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__